import React, { Fragment, lazy, Suspense } from 'react';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const SearchAll = lazy(()=>import('../../components/Shop/SearchAll'))

const SearchPage = () => {
    return (
        <Fragment>
            <Suspense fallback={<LazyLoader/>}>
                <SearchAll/>
            </Suspense>
        </Fragment>
    );
};

export default SearchPage;